export type CompanyStatus = "green" | "yellow" | "red"

export type Company = {
  readonly id: string
  readonly name: string
  readonly area: string
  readonly stage: string
  readonly status: CompanyStatus
}

export const COMPANIES: ReadonlyArray<Company> = [
  { id: "onc", name: "Oncala Bio", area: "Oncology", stage: "Phase 2-Ready", status: "green" },
  { id: "mac", name: "Macala Bio", area: "Macrophage Biology", stage: "IND-Enabling", status: "yellow" },
  { id: "neu", name: "Neurala Bio", area: "Neurodegeneration", stage: "Pre-IND", status: "green" },
  { id: "aut", name: "Autala Bio", area: "Autoimmune", stage: "Pre-IND", status: "yellow" },
  { id: "psy", name: "Psycala Bio", area: "Psychiatry", stage: "Pre-IND", status: "green" },
  { id: "mod", name: "Modala Bio", area: "Metabolic", stage: "Pre-IND", status: "red" },
]
